export const data = [
    {
        id: '113',
        text: 'Россия',
        items: [
            { id: '1', text: 'Москва' },
            { id: '11', text: 'Барнаул' },
            { id: '1220', text: 'Бийск' },
        ],
    },
    {
        id: '16',
        text: 'Беларусь',
        items: [{ id: '1007', text: 'Брест' }],
    },
];

export const dataExtended = [
    {
        id: '113',
        text: 'Россия',
        items: [
            { id: '1', text: 'Москва' },
            { id: '11', text: 'Барнаул' },
            { id: '1220', text: 'Бийск' },
            {
                id: '1620',
                text: 'Республика Марий Эл',
                items: [
                    {
                        id: '4228',
                        text: 'Виловатово',
                        items: [],
                    },
                    {
                        id: '1621',
                        text: 'Волжск',
                        items: [],
                    },
                ],
            },
        ],
    },
    {
        id: '16',
        text: 'Беларусь',
        items: [{ id: '1007', text: 'Брест' }],
    },
];
